"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepMerge = exports.isObject = void 0;
/**
 * @description Method to check if an item is an object. Date and Function are considered
 * an object, so if you need to exclude those, please update the method accordingly.
 * @param item - The item that needs to be checked
 * @return {Boolean} Whether or not @item is an object
 */
var isObject = function (item) {
    return item === Object(item) && !Array.isArray(item);
};
exports.isObject = isObject;
/**
 * @description Method to perform a deep merge of objects
 * @param {Object} target - The targeted object that needs to be merged with the supplied @sources
 * @param {Array<Object>} sources - The source(s) that will be used to update the @target object
 * @return {Object} The final merged object
 */
var deepMerge = function (target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    // return the target if no sources passed
    if (!sources.length) {
        return __assign({}, target);
    }
    var result = __assign({}, target);
    if (exports.isObject(result)) {
        var len = sources.length;
        for (var i = 0; i < len; i += 1) {
            var elm = sources[i];
            if (exports.isObject(elm)) {
                for (var key in elm) {
                    if (elm.hasOwnProperty(key)) {
                        if (exports.isObject(elm[key])) {
                            if (!result[key] || !exports.isObject(result[key])) {
                                result[key] = {};
                            }
                            result[key] = exports.deepMerge(result[key], elm[key]);
                        }
                        else {
                            if (Array.isArray(result[key]) && Array.isArray(elm[key])) {
                                // concatenate the two arrays and remove any duplicate primitive values
                                result[key] = Array.from(new Set(result[key].concat(elm[key])));
                            }
                            else {
                                result[key] = elm[key];
                            }
                        }
                    }
                }
            }
        }
    }
    return result;
};
exports.deepMerge = deepMerge;
//# sourceMappingURL=deepMerge.js.map